import { authStoreUserTournamentId } from 'modules/auth/store/selectors';
import { useGetLogoBackingQuery } from 'modules/organizer/store/logo-backing-api';
import { useSelector } from 'react-redux';

/**
 * Подложка логотипа текущей организации (RTK Query, `logo-backing-api.ts`).
 *
 * `isFetching` — «данных для этой организации ещё нет»: сохранение кладёт ответ в кэш, и фоновых перезапросов,
 * от которых форма профиля мигала бы загрузкой, нет.
 */
export function useFetchLogoBackground() {
  const organizerId = useSelector(authStoreUserTournamentId);
  const skip = !organizerId;

  const query = useGetLogoBackingQuery(organizerId as number, { skip });
  // `currentData`, а не `data`: при смене организации `data` ещё держит подложку прежней.
  const data = query.currentData;

  return {
    data,
    isFetching: !skip && data === undefined && query.isFetching,
  };
}
